import React, { useEffect, useState } from "react";
import Button from "components/Elements/Button/Button.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import Image from "components/Elements/Image/Image.tsx";
import EmbedLimitOptionsModal from "components/Reusable/JUMBOform/Modals/EmbedLimitOptionsModal.js";
import apiRequest from "utils/ApiRequest/apiRequest.js";
import { LinkToNewTab } from "components/Elements/Link/Link.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { Toggle } from "components/Elements/Toggle/Toggle.js";
import { useToasts } from "react-toast-notifications";
import { useUser } from "contexts/userContext/userContext.js";
import { useModal } from "contexts/modalContext/modalContext.js";

const FormsOption = ({
  setSelectedForms,
  selectedForms,
  updateFormsList,
  FullDetailsEmbedPage,
  EmbedPageFormList,
  setEmbedPageFormList,
  showOrderTracker,
  setShowOrderTracker,
  userFormsList,
}) => {
  const { addToast } = useToasts();
  const { getTextByKey } = useContent();
  const { isPremium } = useUser();
  const { setModal } = useModal();
  const [clickOnToggle, setClickOnToggle] = useState(false);
  const [rotateArrow, setRotateArrow] = useState(false);
  const [emptyUnActiveForms, setEmptyUnActiveForms] = useState(false);
  //embed-page-form-required
  const addFormToList = (form) => {
    if (selectedForms.indexOf(form.Embed_Dynamic_Id) === -1) {
      if (isPremium()) {
        setSelectedForms((prev) => [...prev, form.Embed_Dynamic_Id]);
      } else {
        setSelectedForms((prev) => [...prev, form.Embed_Dynamic_Id]);
        setModal(() => (
          <EmbedLimitOptionsModal typeOfModal={"only-one-form-will-display"} />
        ));
      }
    } else {
      if (selectedForms.length > 1) {
        setSelectedForms((prev) =>
          prev.filter((item) => item !== form.Embed_Dynamic_Id)
        );
      } else {
        addToast(getTextByKey("embed-page-form-required"), {
          appearance: "error",
        });
      }
    }
  };
  useEffect(() => {
    const tempList = EmbedPageFormList.map((item) => item.EmbedPageFormId);
    if (selectedForms.length > 0 && selectedForms.length !== tempList.length) {
      const filteredArray = FullDetailsEmbedPage.EmbedDynamicForms.filter(
        (el) => {
          return selectedForms.some((x) => {
            return x === el.Embed_Dynamic_Id;
          });
        }
      );
      const tempFormsList = filteredArray.map((item) => ({
        EmbedPageFormId: item.Embed_Dynamic_Id,
        EmbedPageFormWidth: item.Embed_Dynamic_Width,
        EmbedPageFormHeight: item.Embed_Dynamic_Height,
        EmbedPageFormInnerTitle: item.Embed_Dynamic_Inner_Title,
        EmbedPageFormDisplayTitle: item.Embed_Dynamic_Display_Title,
        EmbedPageFormDescription: item.Embed_Dynamic_Description,
        EmbedPageFormImage: item.Embed_Dynamic_Image_Url,
        isActive: item.Embed_Dynamic_Live_Status,
      }));
      setEmbedPageFormList(tempFormsList);
      updateFormsList();
    }
  }, [selectedForms, EmbedPageFormList]);

  const updateShowOrderTracker = () => {
    if (isPremium()) {
      setClickOnToggle(true);
      setShowOrderTracker((prev) => !prev);
    } else {
      setModal(() => <EmbedLimitOptionsModal />);
    }
  };

  useEffect(() => {
    if (clickOnToggle) {
      reactUpdateOrderTracker();
    }
  }, [showOrderTracker]);

  const reactUpdateOrderTracker = async () => {
    const parameters = {
      embedPageUserName:
        FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageUserName,
      status: showOrderTracker,
    };
    const response = await apiRequest(
      "EmbedDynamics",
      "ReactUpdateOrderTracker",
      parameters
    );
    if (response.status === "success") {
    }
  };

  useEffect(() => {
    if (FullDetailsEmbedPage && FullDetailsEmbedPage.EmbedDynamicForms) {
      if (
        FullDetailsEmbedPage.EmbedDynamicForms.length === selectedForms.length
      ) {
        setEmptyUnActiveForms(true);
      } else {
        setEmptyUnActiveForms(false);
      }
    }
  }, [selectedForms, FullDetailsEmbedPage]);

  const openLimitSubscriptionModal = () => {
    setModal(() => <EmbedLimitOptionsModal />);
  };

  return (
    <div className="forms-option">
      <div className="forms-option-title">
        <span>{getTextByKey("personal-forms-tooltip")}</span>
      </div>
      <div className="select-forms">
        <div className="title">
          <span className="title-span">
            {getTextByKey("select-forms-display")}
          </span>
        </div>
        <div className="selected-forms">
          <div className="forms-sub-title">
            <span>{getTextByKey("active-forms")}</span>
          </div>
          <div
            className="list-forms-div"
            onMouseEnter={() => setRotateArrow(true)}
          >
            <ul>
              {userFormsList.map(
                (item, i) =>
                  item.Embed_Dynamic_Active &&
                  selectedForms.indexOf(item.Embed_Dynamic_Id) !== -1 && (
                    <li key={i}>
                      <div className="select-form-div">
                        <div className="form-details">
                          <div className="image-form-card">
                            <Image
                              title=""
                              alt=""
                              src={
                                item.Embed_Dynamic_Image_Url
                                  ? item.Embed_Dynamic_Image_Url
                                  : null
                              }
                            />
                          </div>
                          <div className="titleAndOff">
                            <span className="name">
                              {item.Embed_Dynamic_Inner_Title}
                            </span>
                            {item.Embed_Dynamic_Live_Status === false && (
                              <div className="off-class">
                                <Image
                                  name="personal/turned-off-icon"
                                  ext="svg"
                                />
                                <span className="off-text">
                                  {getTextByKey("turned-off")}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="icons-container">
                          <div className="edit-form">
                            <LinkToNewTab
                              isNewTab={true}
                              page={"create-form/" + item.Embed_Dynamic_Id}
                            >
                              <span className="icon-edit">
                                <Icon name="pencil-alt-solid" />
                              </span>
                            </LinkToNewTab>
                          </div>
                          <div
                            className="add-icon"
                            onClick={() => addFormToList(item)}
                          >
                            <Tooltip
                              id="remove-form-list-tooltip"
                              tooltipTextKey="remove-form-list-tooltip"
                              top
                            >
                              <div className={`tootltip-icon-container`}>
                                <Icon name="minus" />
                              </div>
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                    </li>
                  )
              )}
            </ul>
          </div>
        </div>
        <div className={`arrow-div ${rotateArrow ? "rotate" : ""}`}>
          <Image name="personal/arrow-forms" alt="" title="" />
        </div>
        <div
          className={`unselected-forms ${
            emptyUnActiveForms ? "empty-list-unselected" : ""
          }`}
        >
          <div className="forms-sub-title">
            <span>{getTextByKey("un-active-forms")}</span>
          </div>
          <div
            className={`list-forms-div ${
              emptyUnActiveForms ? "empty-list" : ""
            }`}
            onMouseEnter={() => setRotateArrow(false)}
          >
            {emptyUnActiveForms ? (
              <div className="empty-list-container">
                {getTextByKey("empty-list-embed-form")}
              </div>
            ) : (
              <ul>
                {userFormsList.map(
                  (item, i) =>
                    item.Embed_Dynamic_Active &&
                    (selectedForms.indexOf(item.Embed_Dynamic_Id) === -1 ? (
                      <li key={i}>
                        <div className="select-form-div">
                          <div className="form-details">
                            <div className="image-form-card">
                              <Image
                                title=""
                                alt=""
                                src={
                                  item.Embed_Dynamic_Image_Url
                                    ? item.Embed_Dynamic_Image_Url
                                    : null
                                }
                              />
                            </div>
                            <div className="titleAndOff">
                              <span className="name">
                                {item.Embed_Dynamic_Inner_Title}
                              </span>
                              {item.Embed_Dynamic_Live_Status === false && (
                                <div className="off-class">
                                  <Image
                                    name="personal/turned-off-icon"
                                    ext="svg"
                                  />
                                  <span className="off-text">
                                    {getTextByKey("turned-off")}
                                  </span>
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="icons-container">
                            <div className="edit-form">
                              <LinkToNewTab
                                isNewTab={true}
                                page={"create-form/" + item.Embed_Dynamic_Id}
                              >
                                <span className="icon-edit">
                                  <Icon name="pencil-alt-solid" />
                                </span>
                              </LinkToNewTab>
                            </div>
                            <div
                              className="add-icon"
                              onClick={() => addFormToList(item)}
                            >
                              <Tooltip
                                id="add-form-list-tooltip"
                                tooltipTextKey="add-form-list-tooltip"
                                top
                              >
                                <div className={`tootltip-icon-container`}>
                                  <Icon name={"plus"} />
                                </div>
                              </Tooltip>
                            </div>
                          </div>
                        </div>
                      </li>
                    ) : null)
                )}
              </ul>
            )}
          </div>
        </div>
        <div className="create-form-button">
          {!isPremium() ? (
            <Button onClick={openLimitSubscriptionModal}>
              <Icon name={"plus"} /> {getTextByKey("create-new-form")}
            </Button>
          ) : (
            <LinkToNewTab isNewTab={true} page={"create-form"}>
              <Button>
                <Icon name={"plus"} /> {getTextByKey("create-new-form")}
              </Button>
            </LinkToNewTab>
          )}
        </div>
        <div className="order-tracker-toggle">
          <Toggle
            status={isPremium() ? showOrderTracker : false}
            setStatus={updateShowOrderTracker}
          />
          <span className="show-order-text">
            {getTextByKey("show-order-tracker")}
          </span>
          <Tooltip
            id="show-order-tracker-tooltip"
            tooltipTextKey="show-order-tracker-tooltip"
            end
          >
            <div className={`tootltip-icon-container`}>
              <Icon name="question-circle" iconClass="tooltip-question" />
            </div>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export default FormsOption;
